module.exports = __webpack_public_path__ + "static/media/card-project3.9e15b8b0.jpg";